import { SecondaryNavigationItem } from 'src/app/core';
import { AngieAppRoutes } from '../../../angie-app.routes';

/**
 * Middle navigation for dashboards
 */
export const middleNavigation: SecondaryNavigationItem[] = [
	{
		id: 'manager-dashboard',
		label: 'lup.manager_dashboard.label',
		url: `/${AngieAppRoutes.MANAGER_DASHBOARD}`,
		active: true,
		permissionCheck: ({ userService, stateService }) => {
			const { manager_dashboard_enabled } = stateService.portalMeta;
			return manager_dashboard_enabled && userService.isManager();
		}
	},
	{
		id: 'admin-dashboard',
		label: 'lup.subnav.lup_admin_dashboard',
		url: '/dashboard',
		permissionCheck: ({ userService }) => {
			return userService.isAdmin();
		}
	},
	{
		id: 'member-dashboard',
		label: 'lup.subnav.lup_dashboard',
		url: '/dashboard',
		permissionCheck: ({ stateService, userService }) => {
			const { enable_ilts, trainings_enabled, show_calendar_on_dash, gamification_enabled, manager_dashboard_enabled } =
				stateService.portalMeta;
			const roleCheck = userService.isLearner() || userService.isInstructor() || userService.isManager();
			const metaCheck = ((enable_ilts || trainings_enabled) && show_calendar_on_dash) || gamification_enabled;
			const managerDashboardCheck = userService.isManager() && manager_dashboard_enabled;
			return roleCheck && metaCheck && !managerDashboardCheck;
		},
		external: true
	},
	{
		id: 'my-courses',
		label: 'lup.subnav.lup_dashboard',
		url: '/dashboard?display=my_courses',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { learner_dashboard_enabled, my_learning_enabled, manager_dashboard_enabled } = stateService.portalMeta;
			return (
				(userService.isAdmin() && (!learner_dashboard_enabled || !my_learning_enabled)) ||
				(userService.isManager() && manager_dashboard_enabled)
			);
		}
	},
	{
		id: 'my-live-sessions',
		label: 'lup.subnav.lup_dashboard_training_calendar',
		url: '/dashboard_training_calendar',
		external: true,
		permissionCheck: ({ stateService }) => {
			const { enable_ilts, trainings_enabled, show_calendar_on_dash } = stateService.portalMeta;
			return (enable_ilts || trainings_enabled) && show_calendar_on_dash;
		}
	},
	{
		id: 'my-achievemnts',
		label: 'lup.gamification.my_achievements',
		url: '/my-awards',
		external: true,
		permissionCheck: ({ stateService }) => {
			const { gamification_enabled, my_learning_enabled } = stateService.portalMeta;
			return gamification_enabled && !my_learning_enabled;
		}
	}
];
